'use client';

import { SvgLoader } from '@/app/elements/svg/loader';
import { useAccountHubUM } from '@/hooks/use-account-hub-um';
import { type RootState, useStore } from '@/store/store';

import './styles/default.scss';

export const AccountHubButton: React.FC = () => {
    const { openAccountHub } = useAccountHubUM();
    const initSessionCompleted = useStore((state: RootState) => state.userContext.session.initCompleted);

    const handleClick = () => {
        if (!initSessionCompleted) {
            console.log('Session not initialized yet. My Account click aborted.');
            return;
        }
        openAccountHub();
    };

    return (
        <SvgLoader
            className={`account-hub-button${!initSessionCompleted ? ' disabled' : ''}`}
            iconName="account-details"
            onClick={handleClick}
        />
    );
};
